<template>
    <div class="flex flex-col items-center">
        <div class="flex items-center justify-start w-full px-3 py-2 space-x-4 border-b border-b-gray-400">
            <img v-if="schoolLogo" :src="schoolLogo" alt="School logo" class="w-10 h-10" />
            <i v-else class="pi pi-graduation-cap text-primary" style="font-size: 2rem;"></i>
            <h2 class="text-white text-lg">SMS</h2>
        </div>
        <div class="flex items-center justify-start w-full px-3 py-2 space-x-4 border-b border-b-gray-400">
            <img v-if="schoolLogo" :src="schoolLogo" alt="School logo" class="w-10 h-10" />
            <i v-else class="pi pi-graduation-cap text-primary" style="font-size: 2rem;"></i>
            <h2 class="text-white text-lg">BOYUNDE</h2>
        </div>
        <div class="-space-y-6 md:-space-y-4 mt-6">
            <router-link to="/teacher/home" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-400': isActiveRoute('/teacher/home'), 'text-white': !isActiveRoute('/teacher/home') }">
                <font-awesome-icon :icon="['fas', 'home']" class="text-left" />
                <span class="mx-4 text-lg font-normal">
                    Home
                </span>
            </router-link>
            <router-link to="/teacher/recordscores" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-400': isActiveRoute('/teacher/recordscores'), 'text-white': !isActiveRoute('/teacher/recordscores') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'edit']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Record scores
                </span>
            </router-link>
            <router-link to="/teacher/assignment" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-400': isActiveRoute('/teacher/assignment'), 'text-white': !isActiveRoute('/teacher/assignment') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'tasks']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Assignment
                </span>
            </router-link>
            <router-link to="/teacher/markbook" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-400': isActiveRoute('/teacher/markbook'), 'text-white': !isActiveRoute('/teacher/markbook') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'book']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Mark book
                </span>
            </router-link>
            <router-link to="/teacher/students" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-400': isActiveRoute('/teacher/students'), 'text-white': !isActiveRoute('/teacher/students') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'users']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Students
                </span>
            </router-link>
            <!-- <router-link to="/teacher" class="flex items-center justify-start text-white w-full p-4 font-bold text-2xl" :class="{ 'text-gray-900': isActiveRoute('/teacher'), 'text-white': !isActiveRoute('/teacher') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'chalkboard-teacher']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    E-class
                </span>
            </router-link> -->
            <!-- <router-link to="/teacher" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-900': isActiveRoute('/teacher/exam'), 'text-white': !isActiveRoute('/teacher/exam') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'file-alt']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Exam
                </span>
            </router-link> -->
            <!-- <router-link to="/teacher/timetable" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-900': isActiveRoute('/teacher/timetable'), 'text-white': !isActiveRoute('/teacher/timetable') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'calendar-alt']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Time Table
                </span>
            </router-link> -->
            <!-- <router-link to="/teacher" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-900': isActiveRoute('/teacher/tasks'), 'text-white': !isActiveRoute('/teacher/tasks') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'tasks']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Tasks
                </span>
            </router-link> -->
            <!-- <router-link to="/teacher" class="flex items-center justify-start w-full p-4 font-bold text-2xl" :class="{ 'text-gray-900': isActiveRoute('/teacher/settings'), 'text-white': !isActiveRoute('/teacher/settings') }">
                <span class="text-left">
                    <font-awesome-icon :icon="['fas', 'cogs']" class="text-left" />
                </span>
                <span class="mx-4 text-lg font-normal">
                    Settings
                </span>
            </router-link> -->
        </div>
    </div>
</template>

<script setup lang="ts">
import { useBranding } from '@/composables/useBranding';

const route = useRoute();

const { schoolLogo } = useBranding();

const isActiveRoute = (path: string) => path === '/' ? route.path === path : route.path.startsWith(path);
</script>
 
